<template>
    <psi-dialog :icon="$config('icons.inactive')" :title="title" @close="$emit('close')">
        <psi-content-loader v-if="dataLoading"></psi-content-loader>
        <div v-else>
            <div id="alert" v-if="hasStudents">
                <v-alert border="top" color="accent" outlined icon="mdi-school">
                    <strong>{{ this.instructorData.name }}</strong> is assigned
                    <v-chip small color="accent darken-2">{{
                        studentCount
                    }}</v-chip>
                    students for the current session
                    <strong>{{ this.currentSession.name }}</strong>. To make this instructor inactive, please re-assign the
                    students to an alternate program instructor.
                </v-alert>
            </div>
            <div v-else>
                <v-alert border="top" color="accent" outlined icon="mdi-school">
                    <strong>{{ this.instructorData.name }}</strong> is not
                    assigned students for the current session
                    <strong>{{ this.currentSession.name }}</strong> and can be
                    made inactive.
                </v-alert>
            </div>
            <div id="re-assign" v-if="hasStudents">
                <v-data-table v-model="selected" show-select hide-default-footer :items="students"
                    :headers="headers"></v-data-table>
                <div class="d-flex align-center">
                    <v-chip label color="accent lighten-1 mr-4">Assign To:</v-chip>
                    <div style="max-width: 300px">
                        <v-select class="mt-6" solo dense name="instructor" label="Choose Instructor"
                            placeholder="Choose Instructor" v-model="selectedInstructor" :items="filteredInstructors"
                            item-text="name" item-value="id" return-object :disabled="selected.length === 0">
                        </v-select>
                    </div>
                    <v-btn class="ml-4" color="accent" :disabled="Object.keys(selectedInstructor).length === 0"
                        @click="assign">
                        <v-icon class="mr-2">mdi-account-multiple-check</v-icon>
                        Assign
                    </v-btn>
                </div>
            </div>
        </div>
        <template #actions>
            <v-btn class="mr-4" @click.stop="$emit('close')">Cancel</v-btn>
            <v-btn color="accent" class="px-4" @click.stop="
                $emit('make-inactive', instructorData.id);
            $emit('close');
                                                " :disabled="hasStudents">
                <v-icon class="mr-1">{{ $config("icons.inactive") }}</v-icon>
                Make Inactive
            </v-btn>
        </template>
    </psi-dialog>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: "instructor-inactive",
    props: {
        program: {
            type: Object,
            required: true,
        },
        instructorData: {
            type: Object,
            required: true,
        },
        currentSession: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            selected: [],
            selectedInstructor: {},
            headers: [
                {
                    text: "Student Name",
                    align: "start",
                    sortable: true,
                    value: "name",
                },
            ],
        };
    },
    computed: {
        ...mapGetters("Programs", ["instructorSessionStudents", "dataLoading"]),
        students() {
            return this.instructorSessionStudents.length === 0
                ? []
                : this.instructorSessionStudents.filter(
                    (student) =>
                        student.instructor_id === this.instructorData.id
                );
        },
        hasStudents() {
            return this.students.length > 0;
        },
        studentCount() {
            return this.students.length;
        },
        title() {
            return `Make ${this.$_.get(
                this.instructorData,
                "name",
                ""
            )} Inactive`;
        },
        filteredInstructors() {
            return Object.keys(this.currentSession) === 0
                ? []
                : this.currentSession.instructors.filter(
                    (instructor) => instructor.id !== this.instructorData.id
                );
        },
    },
    methods: {
        ...mapActions("Programs", [
            "getInstructorSessionStudents",
            "instructorAssignStudents",
        ]),
        assign() {
            this.instructorAssignStudents({
                programId: this.program.id,
                sessionId: this.currentSession.id,
                toInstructorId: this.selectedInstructor.id,
                fromInstructorId: this.instructorData.id,
                students: this.selected.map((student) => student.id),
            });
        },
    },
    mounted() {
        if (this.$_.has(this.currentSession, "id")) {
            const payload = {
                programId: this.program.id,
                instructorId: this.instructorData.id,
                sessionId: this.currentSession.id,
            };
            console.log(payload);
            this.getInstructorSessionStudents(payload);
        }
    },
};
</script>

<style lang="scss" scoped></style>